import Vue from 'vue';
import App from './app.vue';
import iView from 'iview';
import 'babel-polyfill'
import {router} from './router/index';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';
import Ajax from './lib/ajax';
import Util from './lib/util';
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
// import waterfall from 'vue-waterfall2'
// Vue.use(waterfall);
Vue.use(iView);
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
console.log("Viewer:")
console.log(Viewer)
Viewer.setDefaults({
	 // 'inline':true,
	 //    'button':true, //右上角按钮
	 //    "navbar": false, //底部缩略图
	 //    "title": false, //当前图片标题
	 //    "toolbar": true, //底部工具栏
	 //    "tooltip": true, //显示缩放百分比
	 //    "movable": true, //是否可以移动
	 //    "zoomable": true, //是否可以缩放
	 //    "rotatable": true, //是否可旋转
	 //    "scalable": true, //是否可翻转
	 //    "transition": true, //使用 CSS3 过度
	 //    "fullscreen": true, //播放时是否全屏
	 //    "keyboard": true, //是否支持键盘
	 //    "url": "data-source",
})
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video //引入Video播放器


import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
Vue.component('treeselect',Treeselect)


Vue.prototype.$Message.config({
  top: 200,
});

import store from './store/index';
Vue.config.productionTip = false;
import { appRouters,otherRouters} from './router/router';
if(!abp.utils.getCookieValue('Abp.Localization.CultureName')){
  let language=navigator.language;
  abp.utils.setCookieValue('Abp.Localization.CultureName',language,new Date(new Date().getTime() + 5 * 365 * 86400000),abp.appPath);
}
// debugger;
if(window.parent && window.parent!=null){
	window.parent.postMessage('getDomain', '*')
	addEventListener('message', e => {
		if(e.data.type&&e.data.type=="domain"){
			sessionStorage.setItem('domain',e.data.value)
		}
	})
}

Ajax.get('/AbpUserConfiguration/GetAll').then(data=>{
  Util.abp=Util.extend(true,Util.abp,data.data.result);
  new Vue({
    render: h => h(App),
    router:router,
    store:store,
    data: {
      currentPageName: ''
    },
    async mounted () {
      this.currentPageName = this.$route.name as string;
      await this.$store.dispatch({
        type:'session/init'
      })
      if(!!this.$store.state.session.user&&this.$store.state.session.application.features['SignalR']){
        if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
            SignalRAspNetCoreHelper.initSignalR();
        }
      }
      this.$store.commit('app/initCachepage');
      this.$store.commit('app/updateMenulist');
    },
    created () {
      let tagsList:Array<any> = [];
      appRouters.map((item) => {
          if (item.children.length <= 1) {
              tagsList.push(item.children[0]);
          } else {
              tagsList.push(...item.children);
          }
      });
      this.$store.commit('app/setTagsList', tagsList);
    }
  }).$mount('#app')
})

